var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "fleetioVehiclesModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal fleetio-modal",
            "body-class": "scroll-Container",
            title: "Acquisition Vehicles",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.loadVehicles()
            },
          },
        },
        [
          _vm.fleetioVehiclesSpinner
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center py-1",
                },
                [
                  _c("span", {
                    staticClass:
                      "spinner-border spinner-border-md highlightLoader",
                    attrs: { role: "status", "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "highlightLoader p-1 spinner-border-md" },
                    [_vm._v("Loading Data...")]
                  ),
                ]
              )
            : _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "tableHeader" },
                    [
                      _c(
                        "b-form-checkbox-group",
                        {
                          staticClass: "checkboxes",
                          model: {
                            value: _vm.selectedRegions,
                            callback: function ($$v) {
                              _vm.selectedRegions = $$v
                            },
                            expression: "selectedRegions",
                          },
                        },
                        [
                          _c(
                            "b-form-checkbox",
                            { attrs: { size: "lg", value: "North America" } },
                            [_vm._v("NA")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            { attrs: { size: "lg", value: "Europe" } },
                            [_vm._v("EU")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            { attrs: { size: "lg", value: "Japan" } },
                            [_vm._v("JP")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            { attrs: { size: "lg", value: "Middle East" } },
                            [_vm._v("ME")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("vue-bootstrap4-table", {
                    attrs: {
                      rows: _vm.fleetioVehicles.filter((vehicle) =>
                        _vm.selectedRegions.includes(vehicle.group_name)
                      ),
                      columns: _vm.columns,
                      config: _vm.config,
                      classes: _vm.classes,
                    },
                    on: {
                      "on-select-row": function ($event) {
                        return _vm.zoomToFeature($event)
                      },
                    },
                  }),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }